import { useState, useEffect } from "react";

import Swal from "sweetalert2";

import { db } from "../../../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  updateDoc,
  // deleteDoc
} from "firebase/firestore";
import { addDoc } from "firebase/firestore";

import { useNavigate, useParams } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";

import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";

import { Button, Input } from "reactstrap";

import { useTranslation } from "react-i18next";

function AdminSingleRoomPage() {
  const { t } = useTranslation("common");

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const params = useParams();
  const roomUid = params.roomUid;

  // eslint-disable-next-line
  const [room, setRoom] = useState();
  const [uid, setUid] = useState();
  const [league, setLeague] = useState();
  const [status, setStatus] = useState();
  const [sport, setSport] = useState();
  // const [roomMembers, setRoomMembers] = useState();
  const [season, setSeason] = useState();
  const [durationType, setDurationType] = useState("");
  const [tournamentType, setTournamentType] = useState("");

  function compareByPoints(a, b) {
    return b.total - a.total;
  }

  const fetchRoom = async () => {
    try {
      setIsLoading(true);

      const q = query(collection(db, "rooms"), where("uid", "==", roomUid));
      const doc = await getDocs(q);
      // eslint-disable-next-line
      const data = doc.docs[0]?.data();

      setRoom(data);
      setUid(data.uid);
      setLeague(data.leagueName);
      setSeason(data.season);
      setSport(data.leagueSport);
      setStatus(data.isActive);
      setDurationType(data.durationType || "");
      setTournamentType(data.tournamentType || "");
      let fetchedRoomMembers = [...data.members];
      fetchedRoomMembers.sort(compareByPoints);
      setRoomMembers(fetchedRoomMembers);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching tournament data");
    }
  };

  useEffect(() => {
    if (roomUid) {
      fetchRoom();
    }
    // eslint-disable-next-line
  }, [roomUid]);

  const saveChanges = () => {
    Swal.fire({
      text: "Are you sure you want to save your changes to this tournament?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, SAVE",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        try {
          const roomRef = query(
            collection(db, "rooms"),
            where("uid", "==", roomUid)
          );
          const findRooms = await getDocs(roomRef);
          findRooms.forEach(async (room) => {
            const getRoom = doc(db, "rooms", room.id);
            await updateDoc(getRoom, {
              season: season,
              durationType: durationType,
            }).then(() => {
              fetchRoom();
            });
          });

          setIsLoading(false);
        } catch (err) {
          console.error(err);
          setIsLoading(false);
        }
      }
    });
  };

  // const deleteLeague = async () => {
  //   Swal.fire({
  //     text: "Are you sure you want to delete this league?",
  //     icon: 'question',
  //     showCancelButton: true,
  //     confirmButtonColor: '#005EE1',
  //     confirmButtonText: "YES, DELETE",
  //     cancelButtonText: "NO, CANCEL"
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       try {
  //         setIsLoading(true);

  //         const leagueRef = query(collection(db, "leagues"), where("uid", "==", leagueUid));
  //         const findLeagues = await getDocs(leagueRef);
  //         findLeagues.forEach( async (league) => {
  //           const getLeagues = doc(db, 'leagues', league.id);
  //           await deleteDoc(getLeagues);
  //         });

  //         Swal.fire({
  //           text: 'League deleted successfully',
  //           icon: 'success',
  //           confirmButtonColor: '#005EE1',
  //           confirmButtonText: 'OKAY',
  //         })

  //         navigate(-1)

  //         setIsLoading(false);
  //       }  catch (err) {
  //         console.error(err);
  //         alert("An error occured while deleting league");
  //       }
  //     }
  //   })
  // }

  const leaderboardColumns =
    room?.leagueSport === "RACING"
      ? [
          {
            field: "place",
            headerName: "Place",
            flex: 1,
            minWidth: 125,
            maxWidth: 175,
          },
          {
            field: "name",
            headerName: "Name",
            flex: 1,
            minWidth: 150,
            maxWidth: 200,
          },
          {
            field: "points",
            headerName: "Points",
            flex: 1,
            minWidth: 125,
            maxWidth: 175,
          },
          {
            field: "starPoints",
            headerName: "Star points",
            flex: 1,
            minWidth: 150,
            maxWidth: 200,
          },
          {
            field: "total",
            headerName: "Total",
            flex: 1,
            minWidth: 150,
            maxWidth: 120,
          },
        ]
      : [
          {
            field: "place",
            headerName: "Place",
            flex: 1,
            minWidth: 125,
            maxWidth: 175,
          },
          {
            field: "name",
            headerName: "Name",
            flex: 1,
            minWidth: 150,
            maxWidth: 200,
          },
          {
            field: "challengesWon",
            headerName: "Challenges won",
            flex: 1,
            minWidth: 175,
            maxWidth: 225,
          },
          {
            field: "points",
            headerName: "Points",
            flex: 1,
            minWidth: 125,
            maxWidth: 175,
          },
          {
            field: "starPoints",
            headerName: "Star points",
            flex: 1,
            minWidth: 150,
            maxWidth: 200,
          },
          {
            field: "total",
            headerName: "Total",
            flex: 1,
            minWidth: 150,
            maxWidth: 120,
          },
          {
            field: "reward",
            headerName: t("reward"),
            flex: 1,
            minWidth: 150,
            maxWidth: 150,
          },
        ];

  const [groups, setGroups] = useState();
  const fetchGroups = async () => {
    try {
      setIsLoading(true);

      let fetchedGroups = [];

      const q = query(collection(db, "groups"), where("league", "==", league));
      const docs = await getDocs(q);
      docs?.forEach((doc) => {
        const newGroup = doc.data();
        if (league.name === "Liga Mayor de Futbol Salvadoreño") {
          if (room.season === "Clausura 2025") {
            if (newGroup.season === room.season) {
              fetchedGroups.push(newGroup);
            }
          } else {
            if (newGroup.season !== "Clausura 2025") {
              fetchedGroups.push(newGroup);
            }
          }
        } else {
          fetchedGroups.push(newGroup);
        }
      });

      fetchedGroups.sort((a, b) => {
        return new Date(b.openingDateTime) - new Date(a.openingDateTime);
      });

      setGroups(fetchedGroups);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching groups");
    }
  };
  useEffect(() => {
    if (league && room) {
      fetchGroups();
    }
    // eslint-disable-next-line
  }, [league, room]);

  const getLeaderboardReward = (rank, potSize) => {
    switch (rank) {
      case 1:
        return ((potSize * 0.4).toFixed(2) * 100).toFixed(0);
      case 2:
        return ((potSize * 0.25).toFixed(2) * 100).toFixed(0);
      case 3:
        return ((potSize * 0.15).toFixed(2) * 100).toFixed(0);
      case 4:
        return ((potSize * 0.0286).toFixed(2) * 100).toFixed(0);
      case 5:
        return ((potSize * 0.0286).toFixed(2) * 100).toFixed(0);
      case 6:
        return ((potSize * 0.0286).toFixed(2) * 100).toFixed(0);
      case 7:
        return ((potSize * 0.0286).toFixed(2) * 100).toFixed(0);
      case 8:
        return ((potSize * 0.0286).toFixed(2) * 100).toFixed(0);
      case 9:
        return ((potSize * 0.0286).toFixed(2) * 100).toFixed(0);
      case 10:
        return ((potSize * 0.0286).toFixed(2) * 100).toFixed(0);
      default:
        return "0";
    }
  };

  const [roomMembers, setRoomMembers] = useState();
  const getRoomMembers = () => {
    let fetchedRoomMembers = [...room.members];

    fetchedRoomMembers.forEach((member) => {
      let challengesWon = 0;
      let points = 0;
      let starPoints = 0;
      let total = 0;

      room?.submissions?.forEach((submission) => {
        if (submission.submitterUid === member.uid) {
          const group = groups.find((e) => e.uid === submission.groupUid);

          let userChallengesWon = room?.challenges?.filter((e) =>
            e.bets.some(
              (b) => b.bettorUid === member.uid && b.result === e.result
            )
          ).length
            ? room?.challenges?.filter((e) =>
                e.bets.some(
                  (b) => b.bettorUid === member.uid && b.result === e.result
                )
              ).length
            : 0;

          let userPoints = 0;
          let userStarPoints = 0;

          if (room?.leagueSport === "RACING") {
            // console.log(submission?.positions.firstPolePositionDriver, group?.drivers.find(e => e.result === 'firstPolePosition')?.name)
            if (
              submission?.positions.firstPolePositionDriver ===
                group?.drivers.find((e) => e.result === "firstPolePosition")
                  ?.name ||
              submission?.positions.firstPolePositionDriver ===
                group?.drivers.find((e) => e.result === "secondPolePosition")
                  ?.name ||
              submission?.positions.firstPolePositionDriver ===
                group?.drivers.find((e) => e.result === "thirdPolePosition")
                  ?.name
            ) {
              userStarPoints += 2;
            }
            if (
              submission?.positions.secondPolePositionDriver ===
                group?.drivers.find((e) => e.result === "firstPolePosition")
                  ?.name ||
              submission?.positions.secondPolePositionDriver ===
                group?.drivers.find((e) => e.result === "secondPolePosition")
                  ?.name ||
              submission?.positions.secondPolePositionDriver ===
                group?.drivers.find((e) => e.result === "thirdPolePosition")
                  ?.name
            ) {
              userStarPoints += 2;
            }
            if (
              submission?.positions.thirdPolePositionDriver ===
                group?.drivers.find((e) => e.result === "firstPolePosition")
                  ?.name ||
              submission?.positions.thirdPolePositionDriver ===
                group?.drivers.find((e) => e.result === "secondPolePosition")
                  ?.name ||
              submission?.positions.thirdPolePositionDriver ===
                group?.drivers.find((e) => e.result === "thirdPolePosition")
                  ?.name
            ) {
              userStarPoints += 2;
            }
            if (
              submission?.positions.fourthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fourthPlace")?.name ||
              submission?.positions.fourthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
              submission?.positions.fourthPlaceDriver ===
                group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
              submission?.positions.fourthPlaceDriver ===
                group?.drivers.find((e) => e.result === "seventhPlace")?.name ||
              submission?.positions.fourthPlaceDriver ===
                group?.drivers.find((e) => e.result === "eighthPlace")?.name
            ) {
              userPoints += 1;
            }
            if (
              submission?.positions.fifthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fourthPlace")?.name ||
              submission?.positions.fifthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
              submission?.positions.fifthPlaceDriver ===
                group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
              submission?.positions.fifthPlaceDriver ===
                group?.drivers.find((e) => e.result === "seventhPlace")?.name ||
              submission?.positions.fifthPlaceDriver ===
                group?.drivers.find((e) => e.result === "eighthPlace")?.name
            ) {
              userPoints += 1;
            }
            if (
              submission?.positions.sixthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fourthPlace")?.name ||
              submission?.positions.sixthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
              submission?.positions.sixthPlaceDriver ===
                group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
              submission?.positions.sixthPlaceDriver ===
                group?.drivers.find((e) => e.result === "seventhPlace")?.name ||
              submission?.positions.sixthPlaceDriver ===
                group?.drivers.find((e) => e.result === "eighthPlace")?.name
            ) {
              userPoints += 1;
            }
            if (
              submission?.positions.seventhPlaceDriver ===
                group?.drivers.find((e) => e.result === "fourthPlace")?.name ||
              submission?.positions.seventhPlaceDriver ===
                group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
              submission?.positions.seventhPlaceDriver ===
                group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
              submission?.positions.seventhPlaceDriver ===
                group?.drivers.find((e) => e.result === "seventhPlace")?.name ||
              submission?.positions.seventhPlaceDriver ===
                group?.drivers.find((e) => e.result === "eighthPlace")?.name
            ) {
              userPoints += 1;
            }
            if (
              submission?.positions.eighthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fourthPlace")?.name ||
              submission?.positions.eighthPlaceDriver ===
                group?.drivers.find((e) => e.result === "fifthPlace")?.name ||
              submission?.positions.eighthPlaceDriver ===
                group?.drivers.find((e) => e.result === "sixthPlace")?.name ||
              submission?.positions.eighthPlaceDriver ===
                group?.drivers.find((e) => e.result === "seventhPlace")?.name ||
              submission?.positions.eighthPlaceDriver ===
                group?.drivers.find((e) => e.result === "eighthPlace")?.name
            ) {
              userPoints += 1;
            }
            if (submission?.positions.fastestLapDriver === group?.fastestLap) {
              userPoints += 1;
            }
          } else {
            submission?.events.forEach((event) => {
              if (
                event.selectedResult ===
                group?.events.find(
                  (e) =>
                    e.homeTeam === event.homeTeam &&
                    e.awayTeam === event.awayTeam
                )?.result
              ) {
                if (event.isStarGame) {
                  if (
                    room.leagueName === "NBA" ||
                    room.leagueName === "MLB" ||
                    room.leagueName === "NHL"
                  ) {
                    userStarPoints += 1;
                  } else if (
                    room.leagueName === "NFL" ||
                    room.leagueName === "UFL"
                  ) {
                    userStarPoints += 4;
                  } else {
                    userStarPoints += 6;
                  }
                } else {
                  if (
                    room.leagueName === "NBA" ||
                    room.leagueName === "MLB" ||
                    room.leagueName === "NHL"
                  ) {
                    userPoints += 0.25;
                  } else if (
                    room.leagueName === "NFL" ||
                    room.leagueName === "UFL"
                  ) {
                    userPoints += 2;
                  } else {
                    userPoints += 3;
                  }
                }
              } else if (
                group?.events.find(
                  (e) =>
                    e.homeTeam === event.homeTeam &&
                    e.awayTeam === event.awayTeam
                )?.result === "Draw" &&
                (event.selectedResult === "Home" ||
                  event.selectedResult === "Away")
              ) {
                if (event.isStarGame) {
                  userStarPoints += 2;
                } else {
                  userPoints += 1;
                }
              }
            });
          }

          challengesWon = userChallengesWon;
          points += userPoints;
          starPoints += userStarPoints;
          total += userPoints + userStarPoints;
        }
      });

      member.challengesWon = challengesWon;
      member.points = points;
      member.starPoints = starPoints;
      member.total = total;
      if (member.name === "Jose Miguel" && roomUid === "5") {
        member.total += 71;
      }
    });

    fetchedRoomMembers.sort(compareByPoints);
    fetchedRoomMembers.forEach((member, index) => {
      member.place = index + 1;
    });

    // console.log(fetchedRoomMembers);
    fetchedRoomMembers.forEach((member) => {
      let reward = getLeaderboardReward(
        member.place,
        fetchedRoomMembers.length * 4.99
      );

      member.reward = fetchedRoomMembers.length < 10 ? 0 : reward;
    });

    setRoomMembers(fetchedRoomMembers);
  };
  useEffect(() => {
    if (room && groups) {
      getRoomMembers();
    }
    // eslint-disable-next-line
  }, [room, groups]);

  // Helper function to determine entry fee based on tournament type and duration
  const getEntryFee = (tournamentType, durationType) => {
    const type = (tournamentType || "casual").toLowerCase();
    const duration = (durationType || "monthly").toLowerCase();

    const ENTRY_FEES = {
      casual: { monthly: 300, weekly: 100 },
      standard: { monthly: 550, weekly: 200 },
      highstakes: { monthly: 1100, weekly: 300 },
      vipexclusive: { monthly: 2000, weekly: 2000 },
    };

    return ENTRY_FEES[type]?.[duration] || ENTRY_FEES.casual.monthly;
  };

  const closeRoom = () => {
    Swal.fire({
      text: "Are you sure you want to close this tournament?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#005EE1",
      confirmButtonText: "YES, CLOSE TOURNAMENT",
      cancelButtonText: "NO, CANCEL",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        try {
          const roomRef = query(
            collection(db, "rooms"),
            where("uid", "==", roomUid)
          );
          const findRooms = await getDocs(roomRef);
          findRooms.forEach(async (room) => {
            const getRoom = doc(db, "rooms", room.id);
            await updateDoc(getRoom, {
              isActive: false,
            });
          });

          // Check if tournament has less than 10 participants - if so, refund entry fees
          if (roomMembers.length < 10) {
            const entryFee = getEntryFee(
              room?.tournamentType,
              room?.durationType
            );

            // Refund all participants
            for (const member of roomMembers) {
              try {
                const userRef = query(
                  collection(db, "users"),
                  where("uid", "==", member.uid)
                );
                const findUser = await getDocs(userRef);
                if (!findUser.docs.length) continue;
                const userDoc = findUser.docs[0];
                const userData = userDoc.data();
                const previousTickets = Number(userData.tickets || 0);
                const newTickets = previousTickets + entryFee;

                // update user's tickets with refund
                const getUser = doc(db, "users", userDoc.id);
                await updateDoc(getUser, {
                  tickets: newTickets,
                });

                // write wallet transaction audit for the refund
                try {
                  await addDoc(collection(db, "wallet_transactions"), {
                    userUid: member.uid,
                    change: entryFee,
                    currency: "tickets",
                    reason: "tournament_refund_minimum_not_met",
                    tournamentUid: roomUid,
                    tournamentSeason: room?.season || null,
                    tournamentType: room?.tournamentType || null,
                    durationType: room?.durationType || null,
                    previousBalance: previousTickets,
                    newBalance: newTickets,
                    timestamp: new Date(),
                  });
                } catch (auditErr) {
                  console.error(
                    "Failed to write wallet transaction audit for refund:",
                    auditErr
                  );
                }
              } catch (e) {
                console.error("Failed to refund member:", e);
              }
            }

            // Create an admin-facing audit record for the refund
            try {
              await addDoc(collection(db, "audit_tournament_refunds"), {
                tournamentUid: roomUid,
                tournamentSeason: room?.season || null,
                tournamentType: room?.tournamentType || null,
                durationType: room?.durationType || null,
                league: room?.leagueName || null,
                refundedAt: new Date(),
                participantCount: roomMembers.length,
                reason: "minimum_participants_not_met",
                refundAmount: entryFee,
                totalRefunded: roomMembers.length * entryFee,
                participants: roomMembers.map((m) => ({
                  uid: m.uid,
                  name: m.name,
                  refundAmount: entryFee,
                })),
              });
            } catch (auditErr) {
              console.error(
                "Failed to write tournament refund audit:",
                auditErr
              );
            }
          } else {
            // Collect winners (place and reward) and distribute tickets with audit logs
            const tournamentWinners = roomMembers.filter((m) => m.reward > 0);

            if (tournamentWinners.length > 0) {
              // Distribute prizes sequentially to ensure accurate balances and create audit records
              for (const member of tournamentWinners) {
                try {
                  const userRef = query(
                    collection(db, "users"),
                    where("uid", "==", member.uid)
                  );
                  const findUser = await getDocs(userRef);
                  if (!findUser.docs.length) continue;
                  const userDoc = findUser.docs[0];
                  const userData = userDoc.data();
                  const previousTickets = Number(userData.tickets || 0);
                  const award = parseFloat(member.reward) || 0;
                  const newTickets = previousTickets + award;

                  // update user's tickets
                  const getUser = doc(db, "users", userDoc.id);
                  await updateDoc(getUser, {
                    tickets: newTickets,
                  });

                  // write wallet transaction audit for the user
                  try {
                    await addDoc(collection(db, "wallet_transactions"), {
                      userUid: member.uid,
                      change: award,
                      currency: "tickets",
                      reason: "tournament_prize",
                      tournamentUid: roomUid,
                      tournamentSeason: room?.season || null,
                      place: member.place || null,
                      previousBalance: previousTickets,
                      newBalance: newTickets,
                      timestamp: new Date(),
                    });
                  } catch (auditErr) {
                    console.error(
                      "Failed to write wallet transaction audit:",
                      auditErr
                    );
                  }
                } catch (e) {
                  console.error("Failed to distribute prize to member:", e);
                }
              }

              // Create an admin-facing audit record summarizing the distribution
              try {
                await addDoc(collection(db, "audit_prize_distributions"), {
                  tournamentUid: roomUid,
                  tournamentSeason: room?.season || null,
                  league: room?.leagueName || null,
                  distributedAt: new Date(),
                  winners: tournamentWinners.map((w) => ({
                    uid: w.uid,
                    name: w.name,
                    place: w.place,
                    amount: parseFloat(w.reward) || 0,
                  })),
                  totalDistributed: tournamentWinners.reduce(
                    (acc, w) => acc + (parseFloat(w.reward) || 0),
                    0
                  ),
                });
              } catch (auditErr) {
                console.error(
                  "Failed to write prize distribution audit:",
                  auditErr
                );
              }
            }
          }
        } catch (err) {
          console.error(err);
          alert("An error occured while closing tournament");
        }
        setIsLoading(false);
      }
    });
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        TOURNAMENT
      </h1>
      <div>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          ID
        </p>
        <input
          type="text"
          className="mainInput"
          value={uid}
          onChange={(e) => setUid(e.target.value)}
          placeholder="The tournament's ID"
          style={{ marginBottom: "0.5rem" }}
          disabled
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          League
        </p>
        <input
          type="text"
          className="mainInput"
          value={league}
          onChange={(e) => setLeague(e.target.value)}
          placeholder="The tournament's league"
          style={{ marginBottom: "0.5rem" }}
          disabled
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Season
        </p>
        <input
          type="text"
          className="mainInput"
          value={season}
          onChange={(e) => setSeason(e.target.value)}
          placeholder="The tournament's season"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Sport
        </p>
        <input
          type="text"
          className="mainInput"
          value={sport}
          onChange={(e) => setSport(e.target.value)}
          placeholder="The tournament's sport"
          style={{ marginBottom: "0.5rem" }}
          disabled
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Duration type
        </p>
        <Input
          type="select"
          className="mainInput"
          value={durationType}
          onChange={(e) => setDurationType(e.target.value)}
          defaultValue={""}
          style={{ marginBottom: "0.5rem" }}
        >
          <option value="" disabled>
            The tournament's duration type
          </option>
          <option value={"weekly"}>Weekly</option>
          <option value={"monthly"}>Monthly</option>
        </Input>
        {/* 'Tournament type' field removed */}
        {/* 'Type' field removed */}
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Tournament type
        </p>
        <Input
          type="select"
          className="mainInput"
          value={tournamentType}
          onChange={(e) => setTournamentType(e.target.value)}
          defaultValue={""}
          style={{ marginBottom: "0.5rem" }}
        >
          <option value="" disabled>
            The tournament's type
          </option>
          <option value={"casual"}>Casual</option>
          <option value={"standard"}>Standard</option>
          <option value={"highStakes"}>High stakes</option>
          <option value={"vipExclusive"}>VIP exclusive</option>
        </Input>

        <p className="inputLabel" style={{ textAlign: "left" }}>
          Status
        </p>
        <Input
          type="select"
          className="mainInput"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          defaultValue={""}
          style={{ marginBottom: "1rem" }}
          disabled
        >
          <option value="" disabled>
            The tournament's status
          </option>
          <option value={true}>Active</option>
          <option value={false}>Inactive</option>
        </Input>
        <Button
          onClick={closeRoom}
          className="secondaryBtn"
          style={{ marginBottom: "0.5rem" }}
        >
          CLOSE TOURNAMENT
        </Button>
        <Button
          onClick={saveChanges}
          className="primaryBtn"
          style={{ marginBottom: "0.5rem" }}
          disabled={
            room?.season === season &&
            room?.isActive === status &&
            room?.durationType === durationType
          }
        >
          SAVE
        </Button>
        <DataGridPro
          getRowId={(row) => row.uid}
          rows={roomMembers ? roomMembers : []}
          columns={leaderboardColumns}
          // initialState={{
          //   pagination: {
          //     paginationModel: { page: 0, pageSize: 10 },
          //   },
          // }}
          // pageSizeOptions={[10, 25, 50, 100]}
          // onRowClick={handleUserClick}
          checkboxSelection={false}
          slots={{ toolbar: GridToolbar }}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          slotProps={{
            toolbar: {
              printOptions: { disableToolbarButton: true },
              csvOptions: { disableToolbarButton: true },
              showQuickFilter: true,
            },
          }}
        />
        {/* <DataGridPro
          getRowId={(row) => row.uid}
          rows={roomMembers ? roomMembers : []}
          columns={leaderboardColumns}
          // initialState={{
          //   pagination: {
          //     paginationModel: { page: 0, pageSize: 10 },
          //   },
          // }}
          // pageSizeOptions={[10, 25, 50, 100]}
          checkboxSelection={false}
          slots={{ toolbar: GridToolbar }}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          slotProps={{
            toolbar: {
              printOptions: { disableToolbarButton: true },
              csvOptions: { disableToolbarButton: true },
              showQuickFilter: true,
            },
          }}
        /> */}
        {/* <Button onClick={deleteLeague} className='secondaryBtn' style={{marginTop: '0.5rem'}}>
          DELETE
        </Button> */}
      </div>
      {/* <Button onClick={togglePullMembersModal} className='secondaryBtn' style={{marginTop: '0.5rem'}}>
        PULL MEMBERS
      </Button>
      <Modal id='pullMembersModal' isOpen={pullMembersModalIsOpen} toggle={togglePullMembersModal}>
        <ModalBody>
          <div className='modalHeader'>
            <div></div>
					  <IoClose onClick={togglePullMembersModal} />
				  </div>
          <div>
            <h1>
              PULL MEMBERS
            </h1>
            <div style={{marginTop: '1rem'}}>
              <p>
                Choose which room to pull members from
              </p>
              <Input
                type="select"
                className="mainInput"
					      value={roomToPullMembersFrom}
                onChange={(e) => setRoomToPullMembersFrom(e.target.value)}
                defaultValue={''}
					      style={{marginBottom: '1rem'}}          
              >
                <option value={''} disabled>Room to pull members from</option>
                {
                  roomsToPullMembersFrom?.map(room => {
                    return (
                      <option value={room.uid}>{room.uid}</option>
                    )
                  })
                }
              </Input>
              <Button onClick={pullMembers} className='primaryBtn' style={{width: '100%'}} disabled={!roomToPullMembersFrom}>
                PULL MEMBERS
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal> */}
    </div>
  );
}

export default AdminSingleRoomPage;
